export enum PLACEMENT_GROUP {
    NONE,
    TOP,
    BOTTOM
}